import React, { Suspense } from "react";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store";

import "bootstrap/js/index.esm";
import "./index.scss";
import App from "./knightsApp";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import "./i18n";
import { registerChunkErrorRecovery, clearChunkReloadFlag } from "./chunkErrorRecovery";

registerChunkErrorRecovery();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Suspense fallback={<p>Loading translations...</p>}>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<span></span>}>
        <BrowserRouter basename="/">
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </Suspense>
);

// The app rendered on the current build; a stale-chunk reload isn't needed
// again until the next deploy actually changes chunk hashes.
setTimeout(clearChunkReloadFlag, 15000);
